export const aboutData = {
  brandIntro: {
    title: '关于蜜桃传媒',
    subtitle: '专注优质内容创作与传播的媒体平台',
    description: [
      '蜜桃传媒成立于2020年，是一家专注于优质内容创作与传播的新媒体平台。我们致力于为用户提供极致的娱乐体验，汇聚海量精品内容资源，覆盖影视娱乐、生活方式、科技数码、文化艺术、知识教育、音乐之声等多个领域。',
      '平台始终坚持"内容为王"的核心理念，通过严格的内容筛选机制和专业的编辑团队，确保每一篇内容都能为用户带来价值。我们不仅是一个内容分发平台，更是一个连接创作者与读者的桥梁，让优质内容被更多人看见，让创作者得到应有的认可。',
      '经过多年的发展，蜜桃传媒已经成长为拥有500万+月活用户、10万+认证创作者的内容生态平台。我们持续投入技术创新，通过AI推荐算法为用户提供个性化内容推荐，让每一位用户都能在蜜桃传媒找到属于自己的精彩世界。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Modern%20open%20creative%20office%20space%20with%20warm%20natural%20lighting%2C%20collaborative%20workspace%2C%20green%20plants%2C%20people%20working%20on%20laptops%2C%20relaxed%20atmosphere%2C%20minimalist%20design%2C%20high%20ceilings%2C%20art%20on%20walls&width=1200&height=600&seq=about-brand&orientation=landscape',
    values: [
      { icon: 'ri-shield-star-line', title: '品质至上', desc: '严格内容审核，确保平台内容的高品质与可信度' },
      { icon: 'ri-lightbulb-line', title: '创新驱动', desc: '持续技术创新，用AI赋能内容创作与个性化推荐' },
      { icon: 'ri-team-line', title: '创作者为本', desc: '为创作者提供全方位支持，助力优质内容持续产出' },
      { icon: 'ri-heart-pulse-line', title: '用户至上', desc: '以用户需求为核心，打造极致的娱乐阅读体验' },
    ],
  },
  milestones: [
    { year: '2020', event: '蜜桃传媒正式成立，开启内容平台之旅' },
    { year: '2021', event: '月活用户突破100万，创作者数量超5000人' },
    { year: '2022', event: '完成A轮融资，平台内容覆盖六大领域' },
    { year: '2023', event: '月活用户突破300万，上线AI个性化推荐系统' },
    { year: '2024', event: '创作者生态全面升级，认证创作者突破5万人' },
    { year: '2025', event: '月活用户突破500万，成为行业领先内容平台' },
  ],
  awards: [
    { title: '2025年度最佳内容平台', org: '中国新媒体协会', year: '2025' },
    { title: '用户体验创新奖', org: '互联网行业联盟', year: '2024' },
    { title: '优质内容传播平台', org: '文化部数字内容司', year: '2024' },
    { title: '年度创作者友好平台', org: '创作者生态大会', year: '2023' },
  ],
  faqs: [
    {
      question: '蜜桃传媒是一个什么样的平台？',
      answer: '蜜桃传媒是一家专注优质内容创作与传播的媒体平台，汇聚海量精品内容资源，覆盖影视娱乐、生活方式、科技数码、文化艺术、知识教育、音乐之声等多个领域。我们致力于为用户提供极致的娱乐体验，同时为创作者提供优质的展示和变现平台。',
    },
    {
      question: '如何成为蜜桃传媒的认证创作者？',
      answer: '您可以通过"关于我们"页面的"成为创作者"入口提交申请。我们的审核团队会在3-5个工作日内对您的申请进行审核，审核通过后您将获得认证创作者身份，享受流量扶持、收益分成等权益。',
    },
    {
      question: '蜜桃传媒的内容审核标准是什么？',
      answer: '我们坚持"品质至上"的原则，所有内容发布前均需通过专业编辑团队审核。审核标准涵盖原创性、真实性、价值性三个维度，确保平台内容的品质与可信度。我们坚决反对抄袭、虚假信息和低质量内容。',
    },
    {
      question: '在蜜桃传媒发布内容有收益吗？',
      answer: '是的，认证创作者可以通过内容获得收益。我们的收益体系包含基础流量分成、优质内容奖励、品牌合作机会等多个维度。创作者的内容质量和用户互动数据越高，获得的收益也越丰厚。',
    },
    {
      question: '如何联系蜜桃传媒的客服团队？',
      answer: '您可以通过本页面的联系表单提交问题，我们的客服团队会在24小时内回复。您也可以发送邮件至 contact@mitaomedia.com，或在工作日9:00-18:00拨打客服热线 400-XXX-XXXX。',
    },
    {
      question: '蜜桃传媒支持哪些设备访问？',
      answer: '蜜桃传媒全面支持PC端网页、移动端网页、iOS和Android客户端访问。我们的内容在所有设备上均经过优化，确保您在任何设备上都能获得流畅的阅读体验。',
    },
  ],
  contact: {
    email: 'contact@mitaomedia.com',
    phone: '400-XXX-XXXX',
    address: '北京市朝阳区望京SOHO T3-A座 25层',
    workingHours: '周一至周五 9:00 - 18:00',
  },
};